import { render } from "./Chat-main.vue?vue&type=template&id=188b48ac&scoped=true&lang=pug"
import script from "./Chat-main.vue?vue&type=script&setup=true&lang=js"
export * from "./Chat-main.vue?vue&type=script&setup=true&lang=js"

import "./Chat-main.vue?vue&type=style&index=0&id=188b48ac&scoped=true&lang=css"

import exportComponent from "E:\\D\\web\\pyCharm\\arhichat-3.4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-188b48ac"]])

export default __exports__